import type { FormControl, FormGroup, ValidatorFn } from '@angular/forms';

export function emailDomainMatchingValidator<K1 extends string, K2 extends string>(
  emailControl: K1,
  domainControl: K2,
): ValidatorFn {
  return (group: FormGroup<{ [k in K1 | K2]: FormControl<string> }>) => {
    const email = group.controls[emailControl];
    const domain = group.controls[domainControl];
    const emailTrimmed = email.value.split('@')[1];
    const domainTrimmed = domain.value.split('https://')[1];
    const isMismatch = email.value && domain.value && emailTrimmed !== domainTrimmed;

    return isMismatch ? { domainEmailMismatch: true } : null;
  };
}
